import { render, staticRenderFns } from "./master-partner.vue?vue&type=template&id=86fa37c6"
import script from "./master-partner.vue?vue&type=script&lang=js"
export * from "./master-partner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports